import { useCallback, useState } from "react";
import { useConnection, useWallet } from "@solana/wallet-adapter-react";
import {
  JupiterBuildResponse,
  versionedTransactionFromJupiterBuild,
} from "../helpers/jupiterApi";
import { sendVersionedTx } from "./utils/utils";
import mixpanel from "mixpanel-browser";

export const useConvert = () => {
  const { connection } = useConnection();
  const { publicKey, sendTransaction } = useWallet();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const convert = useCallback(
    async (buildResponse: JupiterBuildResponse) => {
      if (!publicKey) {
        setError("Please connect your wallet.");
        return null;
      }

      mixpanel.track("Convert LST", {
        mint: buildResponse.inputMint,
        amount: buildResponse.inAmount,
        wallet: publicKey.toBase58(),
      });

      setLoading(true);
      setError(null);

      try {
        const transaction = versionedTransactionFromJupiterBuild(buildResponse, publicKey);
        return await sendVersionedTx(connection, transaction, sendTransaction);
      } catch (err) {
        setError(`Something went wrong with the transaction: ${err}`);
        return null;
      } finally {
        setLoading(false);
      }
    },
    [connection, publicKey, sendTransaction]
  );

  return { convert, loading, error };
};
